<template>
<v-dialog v-model="show_dialog" max-width="600" persistent>
  <v-card>
    <v-card-title class="secondary white--text">
      <h5>Support</h5>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$eventBus.$emit('play_video',$store.state.app.tutorials.support['Description'])">
        <v-icon>fa-question</v-icon>
      </v-btn>
      <v-btn icon dark @click="close_dialog">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-card-title>


    <div>
      <v-stepper v-model="step">
        <v-stepper-header class="">
          <v-stepper-step :complete="step > 1" step="1">Details</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2">Payment</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step === 3" step="3">Receipt</v-stepper-step>

        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="pa-0">
            <v-card flat>
              <v-container fluid style="max-height:45vh;overflow-y:auto">
                <v-row>
                  <v-col cols="12">

                    <h5 v-if="project">{{project.title}}</h5>
                    <p class="mb-0 mt-3 caption">
                      {{$store.state.app.support_description}}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <v-chip @click="option = this_option" class="ma-1 clicky" :color="option == this_option ? 'cool_purple' : 'green'" text-color="white" v-for="(this_option,i) in $store.state.app.support_options" :key="i">
                      <v-avatar left class="white">
                        <v-icon small :color="this_option == option ? 'cool_purple' :  'green darken-2'">fa-dollar-sign</v-icon>
                      </v-avatar>
                      {{this_option}}
                    </v-chip>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea outlined label="Message to creator (optional)" :rows="3" v-model="payment_info.message"></v-textarea>
                  </v-col>
                </v-row>
              </v-container>

              <v-card-actions class="grey lighten-3">

                <v-spacer></v-spacer>
                <v-btn @click="close_dialog" text>
                  Cancel
                </v-btn>
                <v-btn color="primary" @click="goNext" :loading="loading" :disabled="!canGoNext">
                  Continue
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2" class="pa-0">
            <v-card flat>
              <v-container fluid style="max-height:45vh;overflow-y:auto">

                <v-form ref="support-form" v-model="support_form" lazy-validation>
                  <v-row justify="center" class="pb-4">
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field outlined v-model="payment_info.name" :rules="[rules.required,rules.fullName]" clearable label="Name"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field outlined v-model="payment_info.phone" type="tel" v-mask="'+1 (###) ###-####'" clearable label="Phone Number"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field outlined v-model="payment_info.email" :rules="[rules.required,rules.email]" clearable label="Email address"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <div class="" id="stripeCard">

                      </div>
                    </v-col>
                    <v-col cols="12" class="py-0 text-center" v-if="stripe_error">
                      <span class="error--text caption">{{stripe_error}}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" class="text-center">
                      <span class="caption">By clicking submit you agree to our <a href="/terms" target="_blank">Terms of Use</a>, <a href="/privacy" target="_blank">Privacy Statement</a>, and that you are over 18.</span>
                    </v-col>
                    <v-col cols="12" class="text-right">
                      <h5>Total charge: <span class="cool_purple--text">{{totalCharge}}</span></h5>
                    </v-col>
                  </v-row>
                </v-form>

              </v-container>

              <v-card-actions class="grey lighten-3">
                <v-btn text @click="step=1">Back</v-btn>
                <v-spacer></v-spacer>

                <v-btn color="primary" @click="submitCard" :disabled="!paymentValid" :loading="loading">
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>


          <v-stepper-content step="3" class="pa-0">
            <v-card flat>

              <v-container fluid style="max-height:50vh;overflow-y:auto">
                <v-row class="gradient mb-4 py-4">
                  <v-col cols="12" class="text-center">
                    <v-icon x-large color="white" style="font-size:60px">fas fa-check-circle</v-icon>
                    <h3 class="mt-2 white--text">Payment processed</h3>
                  </v-col>
                </v-row>
                <v-row justify="center">

                  <v-col cols="12" sm="6" v-if="account.thank_you_video">
                    <v-hover v-slot:default="{ hover }">
                      <v-card :elevation="hover ? 12 : 2">
                        <v-card-actions class="secondary  white--text">
                          <v-col cols="12" class="text-center">
                            <h5>Thank You From Creator</h5>
                          </v-col>
                        </v-card-actions>
                        <v-img :src="account.thank_you_video.thumbnail" style="min-height:150px" class="clicky" @click="$eventBus.$emit('play_video',account.thank_you_video.url)">
                          <v-overlay :absolute="true" :value="true" :opacity="0.5">
                            <v-btn color="primary">
                              <v-icon small>fa-play</v-icon>
                            </v-btn>
                          </v-overlay>
                        </v-img>
                      </v-card>
                    </v-hover>
                  </v-col>

                  <v-col cols="12" sm="6" v-if="$store.state.app.support_thanks_video.url">
                    <v-hover v-slot:default="{ hover }">
                      <v-card :elevation="hover ? 12 : 2">
                        <v-card-actions class="secondary white--text">
                          <v-col cols="12" class="text-center">
                            <h5>Thank You From WhyBuy</h5></v-col>
                        </v-card-actions>
                        <v-img :src="$store.state.app.support_thanks_video.thumbnail" style="min-height:150px" class="clicky" @click="$eventBus.$emit('play_video',$store.state.app.support_thanks_video.url)">
                          <v-overlay :absolute="true" :value="true" :opacity="0.5">
                            <v-btn color="primary">
                              <v-icon small>fa-play</v-icon>
                            </v-btn>
                          </v-overlay>
                        </v-img>
                      </v-card>
                    </v-hover>
                  </v-col>

                  <v-col cols="12" class="text-center">
                    <span class="font-weight-bold caption">
                        Your receipt will be sent to <span class="primary--text">{{payment_info.email}}</span>
                    </span>
                  </v-col>
                </v-row>

              </v-container>
              <v-card-actions class="grey lighten-3">
                <v-spacer></v-spacer>

                <v-btn color="primary" @click="close_dialog" :loading="loading">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>



        </v-stepper-items>
      </v-stepper>
    </div>
  </v-card>
</v-dialog>
</template>
<script>
import {
  mask
} from 'vue-the-mask'

export default {
  name: "",
  directives: {
    mask,
  },
  created() {
    this.$eventBus.$on('support', this.show_support)
  },
  watch: {

  },
  data: () => ({
    support_form: '',
    show_dialog: false,
    loading: false,
    step: 1,
    stripe_error: '',
    stripe: null,
    elements: null,
    cardElement: null,
    cardValid: false,
    option: null,
    project: {},
    account: {},
    payment_info: {
      name: '',
      email: '',
      phone: '',
      message: ''
    }
  }),
  computed: {
    totalCharge() {
      return `${this.option}.00 usd`
    },
    canGoNext() {
      if (!this.option) {
        return false
      }
      return true
    },
    paymentValid() {
      if (this.stripe_error) {
        return false
      }
      if (!this.cardValid) {
        return false
      }
      return true
    },
    rules() {
      return {
        fullName: v => v.split(" ").length > 1 || "Full Name Required",
        agree: v => !!v || 'Required',
        phone: v => v.length === 14 || "Invalid Number",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        required: value => !!value || 'Required',
        min: v => v.length >= 8 || 'Min 8 characters'
      }
    }
  },
  methods: {
    async show_support(options) {
      this.step = 1
      this.loading = true
      this.show_dialog = true;
      this.option = options.option || null;
      if (options.account_id) {
        this.account = await this.$api({
          method: "GET",
          url: `/view-profile/${options.account_id}`
        })
      }
      if (options.project_id) {
        this.project = await this.$api({
          method: "GET",
          url: `/projects/${options.project_id}`
        })
      }
      this.loading = false
    },
    close_dialog() {
      if (this.step !== 3) {
        if (!confirm("Sure you want to cancel ?")) {
          return;
        }
      }

      this.step = 1
      this.show_dialog = false
      this.option = null;
      this.project = {};
      this.account = {}
    },
    initStripe() {
      this.stripe = window.Stripe(this.$store.state.app.stripe_key)
      this.elements = this.stripe.elements();
      var style = {
        base: {
          fontSize: '18px',
          color: "#32325d",
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#ccc',
          },
        },
        invalid: {
          color: '#e5424d',
          ':focus': {
            color: '#303238',
          },
        },
      };
      this.cardElement = this.elements.create('card', {
        style: style
      })
      this.step = 1
      this.cardValid = false
      this.stripe_error = false;
      this.cardElement.addEventListener('change', function(event) {
        //alert(JSON.stringify(event))
        if (event.error) {
          this.stripe_error = event.error.message
        } else {
          this.stripe_error = ''
        }
        if (event.complete) {
          this.cardValid = true
        } else {
          this.cardValid = false
        }
      }.bind(this));

      this.$nextTick(() => {
        this.cardElement.mount('#stripeCard');
      });
    },
    goNext() {
      this.initStripe()
      this.step = 2
    },
    async submitCard() {
      if (!this.$refs['support-form'].validate()) {
        return
      }
      this.loading = true;
      this.stripe.createToken(this.cardElement).then(async function(response) {
        if (response.error) {
          this.stripe_error = response.error.message;
          this.loading = false;
        } else {
          try {
            await this.$api({
              method: "POST",
              url: `/support-payment`,
              data: {
                payment_info: this.payment_info,
                token: response.token,
                option: this.option,
                account_id: this.account.id ? this.account.id : null,
                project_id: this.project.id ? this.project.id : null
              }
            })
            this.step = 3
          } catch (ex) {
            this.stripe_error = ex.error
          }
          this.loading = false;
        }
      }.bind(this)).catch(error => {
        console.log("support error", error)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.gradient {
    background: #11998e;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #38ef7d, #11998e);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #38ef7d, #11998e);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
</style>
